export const SET_CURRENT_ELEMENT_PATH = 'SET_CURRENT_ELEMENT_PATH'
export const SET_MENU_DRAFT_LIST = 'SET_MENU_DRAFT_LIST'
export const SET_CREATE_DRAFT_STATE = 'SET_CREATE_DRAFT_STATE'
export const SET_DELETE_DRAFT_STATE = 'SET_DELETE_DRAFT_STATE'
export const SET_DRAFT_INFO = 'SET_DRAFT_INFO'
export const SET_CURRENT_DRAFT = 'SET_CURRENT_DRAFT'
export const SET_GET_CURRENT_DRAFT_STATE = 'SET_GET_CURRENT_DRAFT_STATE'
export const SET_UPDATE_CURRENT_DRAFT_STATE = 'SET_UPDATE_CURRENT_DRAFT_STATE'
export const INCREASE_MODIFICATION_COUNT = 'INCREASE_MODIFICATION_COUNT'
export const RESET_MODIFICATION_COUNT = 'RESET_MODIFICATION_COUNT'
export const CREATE_CATEGORY = 'CREATE_CATEGORY'
export const SET_CATEGORY_PROPERTIES = 'SET_CATEGORY_PROPERTIES'
export const UPDATE_CATEGORIES = 'UPDATE_CATEGORIES'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
export const CREATE_GROUP = 'CREATE_GROUP'
export const SET_GROUP_PROPERTIES = 'SET_GROUP_PROPERTIES'
export const DELETE_GROUP = 'DELETE_GROUP'
export const CREATE_ITEM = 'CREATE_ITEM'
export const SET_ITEM_PROPERTIES = 'SET_ITEM_PROPERTIES'
export const CREATE_QUESTION = 'CREATE_QUESTION'
export const SET_QUESTION_PROPERTIES = 'SET_QUESTION_PROPERTIES'
export const CREATE_OPTION = 'CREATE_OPTION'
export const SET_OPTION_PROPERTIES = 'SET_OPTION_PROPERTIES'
